import { render, staticRenderFns } from "./specialTestRecordDetail.vue?vue&type=template&id=fb4c5fc6"
import script from "./specialTestRecordDetail.vue?vue&type=script&lang=js"
export * from "./specialTestRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./specialTestRecordDetail.vue?vue&type=style&index=0&id=fb4c5fc6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports